// Lean entrypoint for public marketing pages.
// Excludes Lexxy, ActionText, Telnyx, datatables, and other dashboard-only
// libraries to reduce bundle size by ~210 KiB for non-authenticated visitors.

// Hotwire Turbo (navigation + page transitions)
import { Turbo } from "@hotwired/turbo-rails";

Turbo.config.drive.progressBarDelay = 0;

Turbo.StreamActions.redirect = function() {
  const url = this.getAttribute("target");

  if (url) {
    Turbo.visit(url);
  }
};

// Flowbite for nav, dropdowns, modals
import "flowbite";

// Hotwire Stimulus controllers (auto-glob all controllers in this directory)
import "../controllers/index.js";
